import { mapState, mapActions, mapMutations } from 'vuex'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER,
  FNOL_UPDATE_EXECUTION_CODE_MUT,
  FNOL_MAVALUE_REPORT_COMPONENT_MUT,
  FNOL_DAMAGES_CONFIRMED_MUT,
  UPDATE_LOADER,
  FNOL_MODULE_NAME
} from '@/store/types'
import maInputText from '@/components/input/modules/text'
import maInputTextarea from '@/components/input/modules/textarea'
import maInputNumber from '@/components/input/modules/number'
import maInputSelect from '@/components/input/modules/select'
import maInputCheckbox from '@/components/input/modules/checkbox'
import maInputRadio from '@/components/input/modules/radio'
import maButtonBlue from '@/components/button-blue'
import maInputImgradio from '@/components/input/modules/imgRadio'
import { apiPostFnolFlow } from '@/services/API/fnolFlow'
import { apiGetReport } from '@/modules/Claim/services/reports'
import maDatePicker from '@/components/datePicker'
import moment from 'moment'
import {
  MESSAGE,
  TEXT,
  TEXTAREA,
  INTEGER,
  FLOAT,
  SELECT,
  RADIO,
  CHECK,
  MULTICHECK,
  SELFCARE,
  DATE,
  IMAGEBUTTON
} from '@/constants'
import { FLOW_STATES } from '../../modules/Flow/constants'

export default {
  name: 'fnolFlow',

  mixins: [flowMixin],

  data: function () {
    return {
      availableConnections: [],
      dataComponents: [],
      executionCode: '',
      inputValDate: '',
      errorDate: false,
      dateInputs: []
    }
  },

  computed: {
    ...mapState(FNOL_MODULE_NAME, {
      stateExecutionCode: 'executionCode',
      stateDamagesConfirmed: 'damagesConfirmed',
      stateFnolMavalueReportComponentId: 'fnolMavalueReportComponent'
    }),

    areAvailableConnections() {
      return this.availableConnections.length > 0
    },

    checkIfFilled() {
      return this.dataComponents.every((component) => {
        return (
          !component.mandatory ||
          component.type === MESSAGE ||
          (component.value && component.value.length > 0) ||
          this.isMulticheckFilled(component)
        )
      })
    },

    fnolBody: function() {
      return this.getFlowViewOptions ? this.getFlowViewOptions.fnol_body : undefined
    }
  },

  components: {
    maInputText,
    maInputTextarea,
    maInputNumber,
    maInputSelect,
    maInputCheckbox,
    maInputRadio,
    maButtonBlue,
    maDatePicker,
    maInputImgradio
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetSinister: WARRANTY_GET_SINISTER
    }),
    ...mapMutations(FNOL_MODULE_NAME, {
      mutExecutionCode: FNOL_UPDATE_EXECUTION_CODE_MUT,
      mutFnolMavalueReportComponent: FNOL_MAVALUE_REPORT_COMPONENT_MUT,
      mutDamagesConfirmed: FNOL_DAMAGES_CONFIRMED_MUT
    }),
    ...mapMutations({
      updateLoader: UPDATE_LOADER
    }),

    checkInputDateValue() {
      if (this.inputValDate) {
        this.errorDate = false
      } else {
        this.errorDate = true
      }
    },
    initI18n(lang) {
      if (typeof Storage !== 'undefined') {
        let current
        if (lang) {
          current = this.matchLocale(lang)
        } else if (localStorage.getItem('locale')) {
          current = this.matchLocale(localStorage.getItem('locale'))
        } else {
          current = 'fr'
        }
        this.$i18n.locale = current
        localStorage.setItem('locale', current)
      }
    },

    handleChangeInputDate(component) {
      return function (value) {
        component.value = moment(value).format('YYYY-MM-DD')
      }
    },

    async flowInit(params, fnolBody = null) {
      this.updateLoader(true)
      try {
        const data = fnolBody || await apiPostFnolFlow(params).finally(() => this.updateLoader(false))
        this.checkIfContinueToDamages(data)
        this.checkIfFnolFlowIsCompleted(data)
        this.dataComponents = []
        this.updateData(data)
      } catch (error) {
        console.error(error)
        this.goToErrorView()
      }
    },

    updateData(data) {
      this.buildData(data.components)
      this.availableConnections = data.connections
      this.executionCode = data.execution_code
    },

    buildData(responseComponents) {
      responseComponents.forEach((component) => {
        let componentObject = {
          id: component.id,
          type: component.type,
          literal: component.literal,
          hint: component.hint,
          mandatory: component.mandatory || false
        }

        if (component.type === TEXT || component.type === TEXTAREA) {
          componentObject.value = component.value
        } else if (component.type === DATE) {
          componentObject.value = ''
        } else if (component.type === INTEGER) {
          componentObject.value = component.value
          componentObject.floatDigits = 0
        } else if (component.type === FLOAT) {
          componentObject.value = component.value.toString()
          componentObject.floatDigits = 2
        } else if (component.type === SELECT || component.type === RADIO) {
          componentObject.options = []
          component.options.forEach((option) => {
            let opt = {
              key: option.value,
              value: option.value,
              literal: option.literal
            }
            componentObject.options.push(opt)
          })
          componentObject.value =
            componentObject.options.length > 1
              ? componentObject.value
              : componentObject.options[0].value
        } else if (component.type === CHECK) {
          let key = component.id
          componentObject.value = {}
          componentObject.value[key] = component.selected
          componentObject.options = [
            {
              key: component.id,
              value: component.id
            }
          ]
        } else if (component.type === MULTICHECK) {
          componentObject.value = {}
          componentObject.options = []
          component.options.forEach((option) => {
            let opt = {
              key: option.value,
              value: option.value,
              literal: option.literal
            }
            componentObject.options.push(opt)
          })
        } else if (component.type === IMAGEBUTTON) {
          componentObject.value = {}
          componentObject.options = []
          component.options.forEach((option) => {
            let opt = {
              key: option.value,
              value: option.value,
              literal: option.literal,
              image: option.image_src
            }
            componentObject.options.push(opt)
          })
        }

        this.dataComponents.push(componentObject)
      })
    },

    isMulticheckFilled(component) {
      return (
        component.type === MULTICHECK &&
        Object.values(component.value).some((value) => !!value)
      )
    },

    setComponentValue(eventValue, dataComponent) {
      dataComponent.value = eventValue
    },

    checkIfContinueToDamages(data) {
      if (data.components.some((component) => component.type === SELFCARE)) {
        let selfcareComponent = data.components.find(
          (component) => component.type === SELFCARE
        )
        const damagesViewViewName = 'damages-view'
        this.mutExecutionCode(this.executionCode)
        this.mutFnolMavalueReportComponent(selfcareComponent.id)
        this.goToView(damagesViewViewName)
      }
    },

    checkIfFnolFlowIsCompleted(data) {
      if (data.connections.length === 0) {
        this.goToNextState()
      }
    },

    resetStateFNOL() {
      this.mutExecutionCode('')
      this.mutFnolMavalueReportComponent('')
      this.mutDamagesConfirmed(false)
    },

    clickConnection(connectionId) {
      let params = {
        sinister_id: this.getSinisterId,
        components: this.prepareRequestData(),
        connection: connectionId,
        execution_code: this.executionCode,
        id_flux: this.getFnolId,
        lang: localStorage.getItem('locale')
      }
      this.flowInit(params)
    },

    prepareRequestData() {
      let emptiesRemoved = this.removeEmpties()
      return emptiesRemoved.map((component) => {
        if (component.type === MESSAGE) {
          return {
            id: component.id
          }
        } else if (
          component.type === TEXT ||
          component.type === TEXTAREA ||
          component.type === DATE ||
          component.type === RADIO
        ) {
          return {
            id: component.id,
            value: component.value
          }
        } else if (component.type === INTEGER || component.type === FLOAT) {
          return {
            id: component.id,
            value: Number(component.value)
          }
        } else if (component.type === CHECK) {
          let id = component.id
          return {
            id,
            value: 'true'
          }
        } else if (component.type === MULTICHECK) {
          let entries = Object.entries(component.value)
          let entriesFiltered = entries.filter((entrie) => entrie[1] === true)
          let selectedKeys = entriesFiltered.map((entrie) => entrie[0])
          return {
            id: component.id,
            value: selectedKeys
          }
        } else if (component.type === SELECT) {
          return {
            id: component.id,
            value: component.value
          }
        } else if (component.type === IMAGEBUTTON) {
          return {
            id: component.id,
            value: component.value
          }
        }
      })
    },

    removeEmpties() {
      return this.dataComponents.filter((component) => {
        if (
          component.type === TEXT ||
          component.type === TEXTAREA ||
          component.type === INTEGER ||
          component.type === FLOAT ||
          component.type === SELECT
        ) {
          return component.value && component.value.length > 0
        } else if (
          component.type === CHECK ||
          component.type === MULTICHECK ||
          component.type === IMAGEBUTTON
        ) {
          return Object.values(component.value).some((value) => value)
        } else {
          return component
        }
      })
    }
  },

  async mounted() {
    const sinisterId = this.getSinisterId
    await this.actWarrantyGetSinister(sinisterId).then((resp) => {
      if (resp.isSinisterFound == null) {
        this.throwNotification(
          this.$t('notifications.loadSinisterKO.title'),
          this.$t('notifications.loadSinisterKO.body'),
          'KO'
        )
      }
    })
  },

  async created() {
    let params
    let fnolResponse = this.fnolBody
    if (this.stateExecutionCode && this.stateDamagesConfirmed && this.getFlowState === FLOW_STATES.SMART) {
      fnolResponse = null
      await apiGetReport(this.getSinisterId).then((res) => {
        params = {
          sinister_id: this.getSinisterId,
          components: [
            {
              id: this.stateFnolMavalueReportComponentId,
              value: JSON.stringify(res)
            }
          ],
          execution_code: this.stateExecutionCode,
          id_flux: this.getFnolId,
          lang: localStorage.getItem('locale')
        }
      })
    } else {
      params = {
        sinister_id: this.getSinisterId,
        id_flux: this.getFnolId,
        lang: localStorage.getItem('locale')
      }
    }
    await this.flowInit(params, fnolResponse)
    this.resetStateFNOL()
  }
}
